var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-image',{ref:"previewImage",staticStyle:{"display":"none"},attrs:{"src":_vm.firstUrl,"preview-src-list":_vm.fullUrls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }